import React from "react";

import { Node as N } from "../types";
import { Props } from "./types";
import { Node } from "./node";
import { BackArrow } from "./backArrow";
import styles from "./styles.scss";

function Nodes({ node }: Props) {
  const [selectedNode, setSelectedNode] = React.useState(node);
  const [parentNode, setParentNode] = React.useState<N | null>(null);

  return (
    <div className={styles.nodes}>
      {parentNode && (
        <div
          className={styles.parentNode}
          onClick={() => {
            setSelectedNode(parentNode);
            setParentNode(null);
          }}
        >
          <BackArrow className={styles.backArrow} />
          <p className={styles.name}>{parentNode.name}</p>
        </div>
      )}
      <div className={styles.list}>
        {selectedNode.children.map((node) => (
          <div
            key={node.name}
            className={styles.node}
            style={node.type === "folder" ? { cursor: "pointer" } : undefined}
            onDoubleClick={() => {
              if (node.type === "folder") {
                setParentNode(selectedNode);
                setSelectedNode(node);
              }
            }}
          >
            <Node node={node} />
          </div>
        ))}
      </div>
    </div>
  );
}

export { Nodes };
